import jwtAuthAxios from "../../services/jwtAuth";
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { DATE_FORMAT_DD_MM_YYYY } from "constants/DateConstant";
import dayjs from 'dayjs';

export const getAllAdminKrs = createAsyncThunk("adminKrs/getAllAdminKrs", 
async({ page, pageSize, search }, thunkAPI) => {
    try{
        let token = await localStorage.getItem('auth_token');
        jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        const searchParams = search === undefined ? "" : search;
        const url = `v1/master/krs/pageable?page=${page}&size=${pageSize}`
        const response = await jwtAuthAxios.get(url)
        return response.data
    } catch(response){
        throw response
    }
});

export const getMhsKrs = createAsyncThunk("mhsKrs/getMhsKrs",
async(thunkAPI) => {
    try{
        let token = await localStorage.getItem('auth_token');
        jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        const id_prodi = localStorage.getItem('id_prodi');
        const url = `v1/master/krs/param/${id_prodi}`
        const response = await jwtAuthAxios.get(url)
        return response.data
    } catch(response){
        throw response
    }
});

export const getMhsKrsDetail = createAsyncThunk("mhsKrs/getMhsKrsDetail",
async(id,thunkAPI) => {
    try{
        let token = await localStorage.getItem('auth_token');
        jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        const url = `v1/master/krs_detail/master/${id}`
        const response = await jwtAuthAxios.get(url)
        return response.data
    } catch(response){
        throw response
    }
});

export const getDetailKrs = createAsyncThunk("adminKrs/getDetailKrs", async(id) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get(`v1/master/krs_detail/master/${id}`);
    return response.data;
});

export const getPeriodeKrsByKrsId = createAsyncThunk("adminKrs/getPeriodeKrsByKrsIdKrsByKrsId", 
    async(id, { rejectWithValue }) => {
        try {
            const token = localStorage.getItem('auth_token');
            jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            const { data } = await jwtAuthAxios.get(`v1/master/krs/${id}`);
            const { 
                id_program_studi, 
                nama_program_studi,
                semester_mulai_berlaku,
                id_semester,
                id_periode,
                nama_periode,
                kode_periode,
                id_kurikulum,
                nama_kurikulum,
                tanggal_mulai,
                tanggal_selesai,
                ...rest 
            } = data;


            const programStudiId = JSON.stringify({ 
                id_program_studi, 
                nama_program_studi
            });

            const periodeId = JSON.stringify({
                periode_id: id_periode,
                nama: nama_periode,
                kode: kode_periode
            })

            const kurikulumId = JSON.stringify({
                id_kurikulum,
                nama_kurikulum
            })

            return {
                programStudiId,
                periodeId,
                kurikulumId,
                startTime: dayjs(tanggal_mulai, DATE_FORMAT_DD_MM_YYYY),
                stopTime: dayjs(tanggal_selesai, DATE_FORMAT_DD_MM_YYYY),
                ...rest
            };
        } catch(err) {
            rejectWithValue(err?.response?.data?.message || 'error')
        }
    }
);

export const getDataMhsTaken = createAsyncThunk("adminKrs/getDataMhsTaken", async(payload) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.post('v1/view/master/krs/mhs/param',payload);
    return response.data;
});

export const findListMhsFromDosen = createAsyncThunk("adminKrs/findListMhsFromDosen", async(payload) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.post('v1/view/master/krs/mhs/param_dosen',payload);
    return response.data;
});

export const saveAdminKrs = createAsyncThunk("adminKrs/save", async(payload) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.post('v1/krs',payload);
    return response.data;
});

export const saveMasterKrs = createAsyncThunk("adminKrs/saveMasterKrs", async(payload) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.post('v1/master/krs',payload);
    return response.data;
});
export const saveDetailKrs = createAsyncThunk("adminKrs/saveDetailKrs", async(payload) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.post('v1/master/krs_detail',payload);
    return response.data;
});
export const saveDetailKrsValidation = createAsyncThunk("adminKrs/saveDetailKrsValidation", async(payload) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.post('v1/master/krs_detail/validation',payload);
    return response.data;
});

export const updateAdminKrs = createAsyncThunk("adminKrs/update", async(request) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.put('v1/master/krs',request);
    return response.data;
});


export const saveKrsMhs = createAsyncThunk("adminKrs/saveKrsMhs", async(payload) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.post('v1/master/mhs/krs',payload);
    return response.data;
});
export const saveKrsMhsChecking = createAsyncThunk("adminKrs/saveKrsMhsChecking", async(payload) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.post('v1/master/mhs/krs/checking',payload);
    return response.data;
});


export const deleteAdminKrs = createAsyncThunk("adminKrs/deleteAdminKrs", async(id) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    await jwtAuthAxios.delete(`v1/master/krs/${id}`);
    return id;
});

export const deleteKrsMhs = createAsyncThunk("adminKrs/deleteKrsMhs", async(id) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    await jwtAuthAxios.delete(`v1/master/mhs/krs/${id}`);
    return id;
});

export const deleteAdminKrsDetail = createAsyncThunk("adminKrs/deleteAdminKrsDetail", async(id) => {
    const token = localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    await jwtAuthAxios.delete(`v1/master/krs_detail/${id}`);
    return id;
});

const periodeKrs = {
    periodeId: '',
    kurikulumId: '',
    programStudiId: '',
    startTime: '',
    stopTime: ''
}

const pagination = {
	page: 1,
	pageSize: 10,
	pageSizeOptions: ['10', '20', '30', '50'],
	total: null,
}

const initialState = {
    dataAll: [],
    dataKrsId: [],
    dataSaveKrs: [],
    dataUpdateKrs: [],
    dataKrsMhs: [],
    dataKrsDetailMhs: [],
    dataKrsTakenMhs:[],
    listMahasiswaDosen:[],
    dataSaveKrsMhs:{},
    dataSaveKrsMhsChecking:{},
    periodeKrs,
	status: {
		loading: false
	},
    steps: {
		current: 0
	},
	pagination: {
		dataAll: { ...pagination }
	}
}

const adminKrsSlice = createSlice({
    name:"adminKrs",
    initialState: initialState,
    reducers: {
        onRefreshForm: (state) => {
			state.periodeKrs = initialState.periodeKrs
			state.status = initialState.status;
		},
		onRefreshStatus: (state) => {
			state.status = initialState.status;
		},
		onRefreshSteps: (state) => {
			state.steps.current = 0;
		},
		onChangeData: (state, action) => ({
			...state,
			...action.payload
		}),
		onChangePagination: (state, action) => {
			const { paginationName, pageChange, pageSizeChange, totalChange } = action.payload;
			state.pagination[paginationName] = {
				...state.pagination[paginationName],
				page: state.pagination[paginationName].pageSize !== pageSizeChange ? 1 : pageChange,
				pageSize: pageSizeChange,
				total: totalChange,
			}
		},
		nextStep: (state) => {
			state.steps.current++;
		},
		prevStep: (state) => {
			state.steps.current--;
		},
    },
    extraReducers: (builder) => {
    builder
        .addCase(getAllAdminKrs.pending, (state) => {
            state.status.loading = true;
        })
        .addCase(getAllAdminKrs.fulfilled, (state, action) => {
            const { result, page } = action.payload?.data;
			const { number, size, totalElements } = page;
            state.dataAll = result;
            state.pagination.dataAll = {
                ...state.pagination.dataAll,
                page: state.pagination.dataAll.pageSize !== size ? 1 : number + 1,
                pageSize: size,
                total: totalElements,
            }
            state.status.loading = false;
        })
        .addCase(getAllAdminKrs.rejected, (state, action) => {
            state.status.loading = false;
            console.error("Error:", action.error);
        })

    builder
        .addCase(getDetailKrs.pending, (state) => {
            state.status.loading = true;
        })
        .addCase(getDetailKrs.fulfilled, (state, action) => {
            state.dataKrsId = action.payload;
            state.status.loading = false;
        })
        .addCase(getDetailKrs.rejected, (state, action) => {
            state.status.loading = false;
            console.error("Error:", action.error);
        })

    builder
        .addCase(findListMhsFromDosen.pending, (state) => {
            state.status.loading = true;
        })
        .addCase(findListMhsFromDosen.fulfilled, (state, action) => {
            state.listMahasiswaDosen = action.payload;
            state.status.loading = false;
        })
        .addCase(findListMhsFromDosen.rejected, (state, action) => {
            state.status.loading = false;
            console.error("Error:", action.error);
        })

    builder
        .addCase(getDataMhsTaken.pending, (state) => {
            state.status.loading = true;
        })
        .addCase(getDataMhsTaken.fulfilled, (state, action) => {
            state.dataKrsTakenMhs = action.payload;
            state.status.loading = false;
        })
        .addCase(getDataMhsTaken.rejected, (state, action) => {
            state.status.loading = false;
            console.error("Error:", action.error);
        })

    builder
        .addCase(getMhsKrsDetail.pending, (state) => {
            state.status.loading = true;
        })
        .addCase(getMhsKrsDetail.fulfilled, (state, action) => {
            state.dataKrsDetailMhs = action.payload;
            state.status.loading = false;
        })
        .addCase(getMhsKrsDetail.rejected, (state, action) => {
            state.status.loading = false;
            console.error("Error:", action.error);
        })

    builder
        .addCase(getPeriodeKrsByKrsId.pending, (state) => {
            state.status.loading = true;
        })
        .addCase(getPeriodeKrsByKrsId.fulfilled, (state, action) => {
            const { 
                programStudiId,
                periodeId,
                kurikulumId,
                ...rest 
            } = action.payload;
            
            state.periodeKrs = {
                ...state.periodeKrs,
                programStudiId,
                periodeId,
                kurikulumId,
                ...rest
            };

            state.status.loading = false;
        })
        .addCase(getPeriodeKrsByKrsId.rejected, (state, action) => {
            state.status.loading = false;
            console.error("Error:", action.error);
        })
    
    builder
        .addCase(deleteAdminKrs.pending, (state) => {
            state.status.loading = true;
        })
        .addCase(deleteAdminKrs.fulfilled, (state, action) => {
            state.status.loading = false;
        })
        .addCase(deleteAdminKrs.rejected, (state, action) => {
            state.status.loading = false;
            console.error("Error:", action.error);
        })

    builder
        .addCase(deleteKrsMhs.pending, (state) => {
            state.status.loading = true;
        })
        .addCase(deleteKrsMhs.fulfilled, (state, action) => {
            state.status.loading = false;
        })
        .addCase(deleteKrsMhs.rejected, (state, action) => {
            state.status.loading = false;
            console.error("Error:", action.error);
        })

    builder
        .addCase(deleteAdminKrsDetail.pending, (state) => {
            state.status.loading = true;
        })
        .addCase(deleteAdminKrsDetail.fulfilled, (state, action) => {
            state.status.loading = false;
        })
        .addCase(deleteAdminKrsDetail.rejected, (state, action) => {
            state.status.loading = false;
            console.error("Error:", action.error);
        })

    builder
        .addCase(getMhsKrs.pending, (state) => {
            state.status.loading = true;
        })
        .addCase(getMhsKrs.fulfilled, (state, action) => {
            state.dataKrsMhs = action.payload;
            state.status.loading = false;
        })
        .addCase(getMhsKrs.rejected, (state, action) => {
            state.status.loading = false;
            console.error("Error:", action.error);
        })
    builder
        .addCase(saveAdminKrs.pending, (state) => {
            state.status.loading = true;
        })
        .addCase(saveAdminKrs.fulfilled, (state, action) => {
            state.dataSaveKrs = action.payload
            state.status.loading = false;
        })
        .addCase(saveAdminKrs.rejected, (state, action) => {
            state.status.loading = false;
            console.error("Error:", action.error);
        })

    builder
        .addCase(saveKrsMhs.pending, (state) => {
            state.status.loading = true;
        })
        .addCase(saveKrsMhs.fulfilled, (state, action) => {
            state.dataSaveKrsMhs = action.payload
            state.status.loading = false;
        })
        .addCase(saveKrsMhs.rejected, (state, action) => {
            state.status.loading = false;
            console.error("Error:", action.error);
        })

    builder
        .addCase(saveKrsMhsChecking.pending, (state) => {
            state.status.loading = true;
        })
        .addCase(saveKrsMhsChecking.fulfilled, (state, action) => {
            state.dataSaveKrsMhsChecking = action.payload
            state.status.loading = false;
        })
        .addCase(saveKrsMhsChecking.rejected, (state, action) => {
            state.status.loading = false;
            console.error("Error:", action.error);
        })

    builder
        .addCase(saveMasterKrs.pending, (state) => {
            state.status.loading = true;
        })
        .addCase(saveMasterKrs.fulfilled, (state, action) => {
            state.dataSaveKrs = action.payload
            state.status.loading = false;
        })
        .addCase(saveMasterKrs.rejected, (state, action) => {
            state.status.loading = false;
            console.error("Error:", action.error);
        })

    builder
        .addCase(saveDetailKrs.pending, (state) => {
            state.status.loading = true;
        })
        .addCase(saveDetailKrs.fulfilled, (state, action) => {
            state.dataUpdateKrs = action.payload
            state.status.loading = false;
        })
        .addCase(saveDetailKrs.rejected, (state, action) => {
            state.status.loading = false;
            console.error("Error:", action.error);
        })

    builder
        .addCase(saveDetailKrsValidation.pending, (state) => {
            state.status.loading = true;
        })
        .addCase(saveDetailKrsValidation.fulfilled, (state, action) => {
            state.dataUpdateKrs = action.payload
            state.status.loading = false;
        })
        .addCase(saveDetailKrsValidation.rejected, (state, action) => {
            state.status.loading = false;
            console.error("Error:", action.error);
        })

    builder
        .addCase(updateAdminKrs.pending, (state) => {
            state.status.loading = true;
        })
        .addCase(updateAdminKrs.fulfilled, (state, action) => {
            state.dataUpdateKrs = action.payload
            state.status.loading = false;
        })
        .addCase(updateAdminKrs.rejected, (state, action) => {
            state.status.loading = false;
            console.error("Error:", action.error);
        })
    }
})

export const {
    onRefreshForm,
	onRefreshStatus,
	onChangeData,
	nextStep,
	onChangePagination,
	prevStep,
	onRefreshSteps
} = adminKrsSlice.actions

export const selectAdminKrs = (state) => state.adminKrs;
export default adminKrsSlice.reducer;